import { useEffect, useState } from "react";
import type { HealthResponse } from "@wlh/shared-types";
import { getHealth } from "../api";
import { Card, Shell } from "../ui";

type Probe =
  | { state: "loading" }
  | { state: "ok"; health: HealthResponse }
  | { state: "error"; message: string };

/** /status — web <-> API connectivity probe (kept from the Day 1 shell). */
export function StatusPage() {
  const [probe, setProbe] = useState<Probe>({ state: "loading" });

  useEffect(() => {
    let cancelled = false;
    getHealth()
      .then((health) => !cancelled && setProbe({ state: "ok", health }))
      .catch(
        (err: unknown) =>
          !cancelled &&
          setProbe({ state: "error", message: err instanceof Error ? err.message : String(err) }),
      );
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Shell title="Status" subtitle="API health probe">
      <Card>
        {probe.state === "loading" && <p>Checking /api/health…</p>}
        {probe.state === "error" && (
          <p style={{ color: "#b00020" }}>Could not reach the API: {probe.message}</p>
        )}
        {probe.state === "ok" && (
          <dl
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              gap: "0.25rem 1rem",
              margin: 0,
            }}
          >
            {Object.entries(probe.health).map(([k, v]) => (
              <FragmentRow key={k} k={k} v={String(v)} />
            ))}
          </dl>
        )}
      </Card>
    </Shell>
  );
}

function FragmentRow({ k, v }: { k: string; v: string }) {
  return (
    <>
      <dt>{k}</dt>
      <dd style={{ margin: 0 }}>
        <code>{v}</code>
      </dd>
    </>
  );
}
